<template>
  <VField
    class="mb-6"
    error-class="mt-1"
    :error="validationError"
    @change="onChange"
  >
    <VSelect
      :class="$style['select']"
      :options="options"
      :valid="isValid"
      :invalid="isInvalid"
      :optional="optional"
      :loading="loading"
      :disabled="disabled"
      :placeholder="label"
      v-model="city"
      theme="white"
      v-on="$listeners"
      @change="onChange"
    />

    <div
      v-if="networkError"
      slot="error"
      class="absolute text-2xs text-danger-50 mt-1"
    >
      <span>Ha habido un error de conexión. </span>
      <VButton
        theme="link"
        @click="getCities"
      >
        Reintentar
      </VButton>
    </div>
  </VField>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

import {
  VButton,
  VField,
  VSelect
} from '@c/base'

export default {
  components: {
    VButton,
    VField,
    VSelect
  },

  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    optional: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      city: this.value,
      options: {},
      loading: false,
      networkError: false
    }
  },

  computed: {
    validationError () {
      if (this.$v.city.$error && !this.$v.city.required) {
        return this.$t('validate.required', { attribute: this.$t('attributes.city') })
      }

      return ''
    },

    isValid () {
      return !this.networkError &&
             !this.$v.city.$error &&
             this.$v.city.required
    },

    isInvalid () {
      return this.$v.city.$dirty &&
             (
               this.networkError ||
               this.$v.city.$error ||
               !this.$v.city.required
             )
    },

    disabled () {
      return this.loading ||
             this.networkError
    }
  },

  created () {
    this.getCities()
  },

  methods: {
    onChange () {
      this.$v.city.$touch()

      this.$emit('input', this.city)
      this.$emit('change', this.city)
    },

    getCities () {
      this.city = ''
      this.options = {}
      this.networkError = false
      this.loading = true

      return axios.get('/api/cities')
        .then(response => {
          response.data.data.forEach(value => {
            this.$set(this.options, value, value)
          })
        })
        .catch(error => {
          if (!error.status && !error.code) {
            this.networkError = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  validations: {
    city: {
      required
    }
  }
}
</script>

<style lang="scss" module>
.select {
  height: 40px;
}
</style>
